import React from 'react';
import { Navigate } from 'react-router-dom';
import { isSignedIn } from 'library/auth';

export const PatientProtectedRoute = ({ children }: { children: React.ReactElement }) => {
  if (!isSignedIn()) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};
